import React from 'react';
import CustomizedRating from '@components/Customized/CustomizedRating';
import useStyle from './styles';
import { Grid } from '@material-ui/core';
import { CustomizedTypography } from '@components/Customized';
import TextFieldBox from './TextFieldBox';
import { Controller, useFormContext } from 'react-hook-form';
import { RfqReview } from '@modules/review';
import useReview from '@hooks/useReview';
import { useSelector } from '@store';

interface RatingAndCommentBoxProps {
  title: string;
  subTitle: string;
  goodRatingTitle?: string;
  badRatingTitle?: string;
  isRequired: boolean;
}

const RatingAndCommentBox: React.FC<RatingAndCommentBoxProps> = ({
  title,
  subTitle,
  goodRatingTitle,
  badRatingTitle,
  isRequired
}: RatingAndCommentBoxProps) => {
  const classes = useStyle();
  const {
    control,
    formState: { errors },
    watch
  } = useFormContext<RfqReview>();
  const { onUpdateReviewRating } = useReview();
  const defaultTransactionSatisfactionPoint = useSelector(
    (state) => state.review.transactionSatisfactionPoint
  );
  const { transactionSatisfactionPoint } = watch();

  return (
    <Grid
      container
      alignItems="center"
      justifyContent="center"
      className={classes.reviewWrite}
    >
      <Grid
        item
        container
        alignItems="center"
        justifyContent="center"
        className={classes.question}
      >
        <CustomizedTypography
          variant="body1"
          color="textPrimary"
          fontWeight="700"
        >
          {title}
        </CustomizedTypography>
        {isRequired ? (
          <CustomizedTypography variant="body1" color="error" fontWeight="700">
            &nbsp;*
          </CustomizedTypography>
        ) : null}
      </Grid>

      <Grid item container direction="column" alignItems="center">
        <Controller
          name="transactionSatisfactionPoint"
          defaultValue={defaultTransactionSatisfactionPoint}
          control={control}
          rules={{ required: true, min: 1 }}
          render={({ onChange }) => (
            <CustomizedRating
              name="transactionSatisfactionPoint"
              size="large"
              value={transactionSatisfactionPoint ?? 0}
              onChange={(newValue) => {
                onUpdateReviewRating(newValue ?? undefined);
                onChange(newValue);
              }}
            />
          )}
        />
        {!!errors.transactionSatisfactionPoint && (
          <CustomizedTypography variant="caption" color="error">
            별점을 선택하세요
          </CustomizedTypography>
        )}
      </Grid>

      <Grid item className="comment">
        <Grid
          container
          alignItems="center"
          justifyContent="center"
          className={classes.question}
        >
          {transactionSatisfactionPoint && transactionSatisfactionPoint > 0 ? (
            <CustomizedTypography
              variant="body1"
              color="textPrimary"
              fontWeight="700"
            >
              제품 품질에 {transactionSatisfactionPoint}점을 주셨네요
              {transactionSatisfactionPoint >= 4 ? '!' : '.'}
            </CustomizedTypography>
          ) : null}

          <CustomizedTypography
            variant="body1"
            color="textPrimary"
            fontWeight="700"
          >
            {transactionSatisfactionPoint || transactionSatisfactionPoint === 0
              ? transactionSatisfactionPoint >= 4
                ? goodRatingTitle
                : badRatingTitle
              : subTitle}
          </CustomizedTypography>
          {isRequired ? (
            <CustomizedTypography
              variant="body1"
              color="error"
              fontWeight="700"
            >
              &nbsp;*
            </CustomizedTypography>
          ) : null}
        </Grid>
        <TextFieldBox
          placeholder={`욕설, 비방성 글, 허위 사실을 작성할 경우 후기 삭제 및 플랫폼 이용 제한 조치가 이루어질 수 있습니다.`}
        />
      </Grid>
    </Grid>
  );
};

export default RatingAndCommentBox;
